import { render } from "./Users.vue?vue&type=template&id=170e7b21"
import script from "./Users.vue?vue&type=script&lang=ts"
export * from "./Users.vue?vue&type=script&lang=ts"

import "./Users.vue?vue&type=style&index=0&id=170e7b21&lang=scss"
script.render = render

export default script